import React, { useState, useEffect } from "react";
import PageWrapper from "../components/PageWrapper";

import Slider from "react-slick";

// Import slick-carousel CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { BaseURL, getData } from "../FatchApi/FatchApi";

import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "../components/Loader/Spinner";

const ManageImages = () => {
  const [allImages, setAllImages] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [newBanners, setNewBanners] = useState({
    homePramotionBanner: "",
    homeGiftBanner: "",
    contactUsBanner: "",
    aboutUsBanner: "",
  });

  // CTA state per banner: { bannerKey: { ctaUrl, title } }
  const [bannerCta, setBannerCta] = useState({
    homePramotionBanner: { ctaUrl: "", title: "" },
    homeGiftBanner: { ctaUrl: "", title: "" },
    contactUsBanner: { ctaUrl: "", title: "" },
    aboutUsBanner: { ctaUrl: "", title: "" },
  });
  const [ctaSaving, setCtaSaving] = useState({});

  const [generalImages, setGeneralImages] = useState([]);
  const [newGeneralImage, setNewGeneralImage] = useState({ file: null, ctaUrl: '', title: '' });
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const getImages = async () => {
    const res = await getData("api/images/get-all-images/allbanners");
    setAllImages(res.banners);
    // Pre-populate CTA fields from existing data
    if (res.banners) {
      setBannerCta((prev) => {
        const updated = { ...prev };
        Object.keys(updated).forEach((key) => {
          if (res.banners[key]) {
            updated[key] = {
              ctaUrl: res.banners[key].ctaUrl || "",
              title: res.banners[key].title || "",
            };
          }
        });
        return updated;
      });
    }
  };
  useEffect(() => {
    getImages();
  }, []);

  let BannerKeys = [];
  for (let key in newBanners) {
    if (key !== "heroBanner") {
      BannerKeys.push(key);
    }
  }

  const handleImageChange = (event, index) => {
    const file = event.target.files[0];
    const name = event.target.name;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setNewBanners((prev) => ({
        ...prev,
        [name]: reader.result,
      }));
    };
  };

  /** Upload image + CTA together */
  const uploadBanner = async (item) => {
    setSpinner(true);
    try {
      const res = await axios.post(`${BaseURL}/api/images/other-banner-upload`, {
        [item]: newBanners[item],
        ctaUrl: bannerCta[item]?.ctaUrl || "",
        title: bannerCta[item]?.title || "",
      });
      if (res.data?.success) {
        setNewBanners((prev) => ({ ...prev, [item]: "" }));
        getImages();
      }
    } catch (err) {
      alert("Upload failed: " + (err?.response?.data?.error || err.message));
    } finally {
      setSpinner(false);
    }
  };

  /** Save ONLY the CTA fields — no image re-upload needed */
  const saveBannerCta = async (bannerKey) => {
    setCtaSaving((prev) => ({ ...prev, [bannerKey]: true }));
    try {
      const res = await axios.patch(`${BaseURL}/api/images/other-banner-cta-update`, {
        bannerKey,
        ctaUrl: bannerCta[bannerKey]?.ctaUrl || "",
        title: bannerCta[bannerKey]?.title || "",
      });
      if (res.data?.success) {
        getImages();
        alert("CTA saved successfully!");
      }
    } catch (err) {
      alert("CTA save failed: " + (err?.response?.data?.error || err.message));
    } finally {
      setCtaSaving((prev) => ({ ...prev, [bannerKey]: false }));
    }
  };

  // ===== GENERAL IMAGES FUNCTIONS =====
  const getGeneralImages = async () => {
    try {
      const res = await getData('api/images/get-general-images');
      setGeneralImages(res.generalImages || []);
    } catch (error) {
      console.error('Failed to fetch general images:', error);
    }
  };

  /**
   * Step 1: User selects file → store it in state (do NOT upload yet).
   * We need the file stored so we can read ctaUrl & title on submit.
   */
  const handleGeneralImageFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 1024 * 1024) {
      alert('File too large (>1MB). Please use AVIF/WebP under 1MB.');
      return;
    }
    setNewGeneralImage((prev) => ({ ...prev, file }));
    e.target.value = '';
  };

  /**
   * Step 2: User clicks "Add Image" → read file as base64, then POST to backend.
   * At this point ctaUrl and title are already in state.
   */
  const addGeneralImage = () => {
    if (!newGeneralImage.file) {
      alert('Please select an image first.');
      return;
    }
    const reader = new FileReader();
    reader.onloadend = async () => {
      try {
        setSpinner(true);
        const res = await axios.post(
          `${BaseURL}/api/images/general-image-upload`,
          {
            image: reader.result,          // base64 data URL → Cloudinary
            ctaUrl: newGeneralImage.ctaUrl,
            title: newGeneralImage.title,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        if (res.data.success) {
          getGeneralImages();
          setNewGeneralImage({ file: null, ctaUrl: '', title: '' });
        } else {
          alert('Upload failed: ' + (res.data.error || 'Unknown error'));
        }
      } catch (error) {
        alert('Upload failed: ' + (error?.response?.data?.error || error.message));
      } finally {
        setSpinner(false);
      }
    };
    reader.readAsDataURL(newGeneralImage.file);
  };

  const deleteGeneralImage = async (index) => {
    if (window.confirm('Delete this image?')) {
      try {
        setSpinner(true);
        const res = await axios.delete(
          `${BaseURL}/api/images/general-image-delete/${index}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        if (res.data.success) {
          getGeneralImages();
        }
      } catch (error) {
        alert('Delete failed: ' + (error?.response?.data?.error || error.message));
      } finally {
        setSpinner(false);
      }
    }
  };

  useEffect(() => {
    getGeneralImages();
  }, []);
  // console.log(BannerKeys);
  function splitCamelCase(str) {
    // Split the string where there's a capital letter and join with spaces
    const splitString = str.replace(/([a-z])([A-Z])/g, "$1 $2");

    // Capitalize the first letter of each word
    const capitalized = splitString.replace(/\b\w/g, (char) =>
      char.toUpperCase()
    );

    return capitalized;
  }
  const heroDemo = [
    "../camera-placeholder.png",
    "../camera-placeholder.png",
    "../camera-placeholder.png",
  ];
  const heroData = [];
  for (const key in allImages?.heroBanner) {
    heroData.push(key);
  }
  return (
    <PageWrapper>
      {spinner ? <Spinner /> : ""}
      <section className="bg-gradient-to-b from-gray-200 to-gray-400 bg-fixed h-full pt-5">
        <div className="container mx-auto px-4 w-full max-w-4xl">
          <div className="relative">
            <Slider {...settings}>
              {allImages?.heroBanner
                ? heroData.map((item, index) => (
                    <div className="relative group p-2" key={index}>
                      <Link to="/manage-images/hero-banner-change">
                        <img
                          src={allImages?.heroBanner[item]?.url}
                          className="object-cover w-full h-auto rounded-lg transition-transform duration-300 ease-in-out group-hover:scale-105"
                          alt="Best spices and masala brand in India"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="text-white text-lg font-semibold">
                            <h2 className="text-xl">
                              Hero Banner on Home page
                            </h2>
                            <p className="mt-2">Click On Banner to change it</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                : heroDemo.map((src, index) => (
                    <div className="relative group p-2" key={index}>
                      <Link to="/manage-images/hero-banner-change">
                        <img
                          src={src}
                          className="object-cover w-full h-auto rounded-lg transition-transform duration-300 ease-in-out group-hover:scale-105"
                          alt="Best spices and masala brand in India"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="text-white text-lg font-semibold">
                            <h2 className="text-xl">
                              Hero Banner on Home page
                            </h2>
                            <p className="mt-2">Click On Banner to change it</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
            </Slider>
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-b from-gray-200 to-gray-400 bg-fixed h-full mt-5">
        <div className="container mx-auto">
          <h1 className="text-center text-4xl text-white mb-2">
            Other Banners
          </h1>
          <p className="text-center text-blue-100 mb-6 text-sm">
            Each banner supports an optional CTA Title and URL — shown as a clickable link on the frontend.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {BannerKeys.map((item, i) => {
              const existing = allImages?.[item];
              const hasCta = existing?.ctaUrl;
              return (
                <div key={item} className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 shadow-xl">
                  {/* Banner Title */}
                  <h2 className="mb-3 text-lg font-bold text-white flex items-center gap-2">
                    {splitCamelCase(item)}
                    {hasCta && (
                      <span className="text-xs bg-green-500 text-white px-2 py-0.5 rounded-full">
                        CTA Active
                      </span>
                    )}
                  </h2>

                  {/* Image Preview */}
                  <div className="relative group rounded-xl overflow-hidden mb-4">
                    <img
                      src={
                        (newBanners && newBanners[item]) ||
                        (allImages && allImages[item]?.url) ||
                        "../camera-placeholder.png"
                      }
                      alt={`${splitCamelCase(item)} preview`}
                      className="w-full h-44 object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="inset-0 hidden group-hover:absolute group-hover:flex bg-black bg-opacity-50 items-center justify-center transition-opacity duration-300">
                      <label
                        htmlFor={`file${i}`}
                        role="button"
                        className="bg-white text-gray-800 font-semibold py-2 px-4 rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 cursor-pointer"
                      >
                        Change Image
                      </label>
                    </div>
                    <input
                      type="file"
                      name={item}
                      className="hidden"
                      id={`file${i}`}
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, i)}
                    />
                  </div>

                  {/* CTA Fields */}
                  <div className="space-y-2 mb-4">
                    <div>
                      <label className="block text-xs font-bold text-white/80 mb-1 uppercase tracking-wide">
                        CTA Title <span className="text-white/50 font-normal">(optional)</span>
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. Shop Now"
                        value={bannerCta[item]?.title || ""}
                        onChange={(e) =>
                          setBannerCta((prev) => ({
                            ...prev,
                            [item]: { ...prev[item], title: e.target.value },
                          }))
                        }
                        className="w-full px-3 py-2 rounded-lg bg-white/20 text-white placeholder-white/50 border border-white/20 focus:outline-none focus:border-white/60 text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-white/80 mb-1 uppercase tracking-wide">
                        CTA URL <span className="text-white/50 font-normal">(optional)</span>
                      </label>
                      <input
                        type="url"
                        placeholder="https://example.com/promo"
                        value={bannerCta[item]?.ctaUrl || ""}
                        onChange={(e) =>
                          setBannerCta((prev) => ({
                            ...prev,
                            [item]: { ...prev[item], ctaUrl: e.target.value },
                          }))
                        }
                        className="w-full px-3 py-2 rounded-lg bg-white/20 text-white placeholder-white/50 border border-white/20 focus:outline-none focus:border-white/60 text-sm"
                      />
                    </div>
                  </div>

                  {/* Buttons Row */}
                  <div className="flex flex-wrap gap-2">
                    {/* Save CTA only (no image re-upload) */}
                    <button
                      onClick={() => saveBannerCta(item)}
                      disabled={ctaSaving[item]}
                      className="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-sm font-bold py-2 px-4 rounded-lg transition-all disabled:opacity-50"
                    >
                      {ctaSaving[item] ? "Saving…" : "💾 Save CTA"}
                    </button>

                    {/* Upload new image + save CTA together */}
                    {newBanners[item] && (
                      <button
                        onClick={() => uploadBanner(item)}
                        disabled={spinner}
                        className="flex-1 bg-green-600 hover:bg-green-700 text-white text-sm font-bold py-2 px-4 rounded-lg transition-all disabled:opacity-50 flex items-center justify-center gap-2"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 fill-white" viewBox="0 0 32 32">
                          <path d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z" />
                          <path d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z" />
                        </svg>
                        {spinner ? "Uploading…" : "Upload Image"}
                      </button>
                    )}
                  </div>

                  {/* Current CTA info */}
                  {existing?.ctaUrl && (
                    <div className="mt-3 text-xs text-green-300 bg-green-900/30 rounded-lg p-2">
                      <span className="font-bold">Active CTA:</span>{" "}
                      {existing.title && <span className="mr-2">"{existing.title}"</span>}
                      <a href={existing.ctaUrl} target="_blank" rel="noopener noreferrer" className="underline break-all">
                        {existing.ctaUrl}
                      </a>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* ===== GENERAL IMAGES WITH CTA ===== */}
        <section className="bg-gradient-to-b from-gray-200 to-gray-400 bg-fixed h-full mt-8 p-8">
          <div className="container mx-auto">
            <h1 className="text-center text-4xl text-white mb-8 font-bold">
              General Images (w/ CTA)
            </h1>
            <span className="block text-center text-blue-200 mb-6 text-lg font-medium">
              Recommended: 500x500px (1:1) or 16:9 landscape, Less then 1MB, AVIF/WebP
            </span>
            
              {/* Add Form */}
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">Add New Image</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <input
                    type="file"
                    id="generalImage"
                    accept="image/*"
                    onChange={handleGeneralImageFileSelect}
                    className="p-3 border border-white/30 rounded-xl bg-white/20 text-white file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:bg-blue-500 file:text-white hover:file:bg-blue-600 w-full"
                  />
                  {newGeneralImage.file && (
                    <p className="text-green-300 text-xs mt-1 font-medium">
                      ✓ Selected: {newGeneralImage.file.name}
                    </p>
                  )}
                </div>
                <input
                  type="url"
                  placeholder="CTA URL (optional)"
                  className="p-3 border border-white/30 rounded-xl bg-white/20 text-white placeholder-gray-300"
                  value={newGeneralImage.ctaUrl}
                  onChange={(e) => setNewGeneralImage({...newGeneralImage, ctaUrl: e.target.value})}
                />
                <input
                  type="text"
                  placeholder="Title (optional)"
                  className="p-3 border border-white/30 rounded-xl bg-white/20 text-white placeholder-gray-300"
                  value={newGeneralImage.title}
                  onChange={(e) => setNewGeneralImage({...newGeneralImage, title: e.target.value})}
                />
              </div>
              <button
                onClick={addGeneralImage}
                disabled={!newGeneralImage.file || spinner}
                className="mt-4 bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-xl font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {spinner ? 'Uploading...' : '+ Add Image'}
              </button>
            </div>

            {/* Images Table */}
            <div className="bg-white/10 backdrop-blur-md rounded-2xl overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-white/20">
                      <th className="p-4 text-left text-white font-bold">Preview</th>
                      <th className="p-4 text-left text-white font-bold">Title</th>
                      <th className="p-4 text-left text-white font-bold">CTA URL</th>
                      <th className="p-4 text-right text-white font-bold">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {generalImages.map((img, index) => (
                      <tr key={index} className="border-t border-white/10 hover:bg-white/5">
                        <td className="p-4">
                          <div className="relative w-20 h-20 rounded-xl overflow-hidden shadow-lg">
                            <img src={img.url} alt={img.title} className="w-full h-full object-cover" />
                            {img.ctaUrl && (
                              <div className="absolute inset-0 bg-blue-500 bg-opacity-20 flex items-center justify-center opacity-0 hover:opacity-100 transition-all">
                                <span className="text-blue-100 text-xs font-bold bg-blue-600 px-2 py-1 rounded">CTA</span>
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="p-4 font-medium text-white">{img.title || '—'}</td>
                        <td className="p-4 max-w-md">
                          <a href={img.ctaUrl} target="_blank" rel="noopener noreferrer" className="text-blue-300 hover:text-blue-100 truncate block">
                            {img.ctaUrl || '—'}
                          </a>
                        </td>
                        <td className="p-4 text-right">
                          <button
                            onClick={() => deleteGeneralImage(index)}
                            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg font-bold text-sm transition-all ml-2"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

      </section>
    </PageWrapper>
  );
};

export default ManageImages; 
